import { Select, Spinner } from '@chakra-ui/react'
import { ChangeEvent, useEffect, useState } from 'react'
import { render } from 'redity'
import colors from '../../../config/theme/colors'
import useStorage from '../../../hooks/useStorage'
import CashBox from '../../../models/cashbox'
import { Keys } from '../constant'
import { storagePage } from '../storage'
import loadMain from '../utilities/loadMain'

export default function CashboxField() {
    const { cashboxes } = useStorage()
    const [isLoading, setLoading] = useState(false)
    const id = storagePage.currentCashbox?.id || 0

    // Si aún no hay caja seleccionada en el store y ya cargaron las cajas,
    // inicializamos con la primera de la lista (que es la que el <select>
    // nativo termina mostrando por defecto visualmente).
    useEffect(() => {
        if (storagePage.currentCashbox) return
        if (!cashboxes || cashboxes.length === 0) return
        ;(async () => {
            storagePage.currentCashbox = cashboxes[0]
            setLoading(true)
            await loadMain(cashboxes[0].id)
            render(Keys.MAIN)
            setLoading(false)
        })()
        // eslint-disable-next-line
    }, [cashboxes])

    async function changeHandler(ev: ChangeEvent<HTMLSelectElement>) {
        storagePage.currentCashbox = cashboxes.find(
            cashbox => cashbox.id === parseInt(ev.target.value)
        ) as CashBox
        setLoading(true)
        await loadMain(storagePage.currentCashbox?.id || 1)
        render(Keys.MAIN)
        setLoading(false)
    }

    return (
        <>
            <Select
                w="auto"
                size="md"
                bg={colors['base-4']}
                borderRadius="full"
                fontFamily="Poppins-Semibold"
                defaultValue={id}
                onChange={changeHandler}
            >
                {cashboxes.map(cashbox => (
                    <option value={cashbox.id} key={cashbox.id}>
                        {cashbox.name}
                    </option>
                ))}
            </Select>
            {isLoading && <Spinner ml={4} color="gray-3" />}
        </>
    )
}
